import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalDrawer: {
    defaultMessage: 'Import Suppliers from CSV',
    id: 'BZjAln',
    description: 'Supplier Import Modal Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'IQ2vdL',
    description: 'Title on the first step of the import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'ZUIKqi',
    description: 'Create mapping step title message',
  },
  importResult: {
    id: '4ZaRoO',
    defaultMessage: 'Import Suppliers',
    description: 'Title of import is processing step',
  },
  importDetailsSuccess: {
    id: '3HEbE2',
    defaultMessage: 'We successfully processed {processed, plural, one {# supplier} other {# suppliers}}.',
    description: 'Successfully imported suppliers count message',
  },
  importResultSuccess: {
    id: 'UKnSus',
    defaultMessage: 'Suppliers Successfully Imported',
    description: 'Title of success import',
  },
});

export const fieldsTranslations = defineMessages({
  supplier_name: {
    defaultMessage: 'Supplier Name',
    id: '+8VKCf',
    description: 'Supplier Name import column name',
  },
  supplier_email: {
    defaultMessage: 'Supplier Email',
    id: 'zXxx8J',
    description: 'Supplier Email import column name',
  },
  address_line_1: {
    defaultMessage: 'Address Line 1',
    id: 'lNgEzT',
    description: 'Address Line 1 import column name',
  },
  address_line_2: {
    defaultMessage: 'Address Line 2',
    id: '1PfINp',
    description: 'Address Line 2 import column name',
  },
  city: {
    defaultMessage: 'City',
    id: 'VZ+KzV',
    description: 'City import column name',
  },
  state: {
    defaultMessage: 'State',
    id: 'GOiGjd',
    description: 'State import column name',
  },
  country_code: {
    defaultMessage: 'Country Code',
    id: '7YnTZA',
    description: 'Country Code import column name',
  },
  postal_code: {
    defaultMessage: 'Postal Code',
    id: 'oM6qer',
    description: 'Postal Code import column name',
  },
  contact_name: {
    defaultMessage: 'Contact Name',
    id: 'qWl4SI',
    description: 'Contact Name import column name',
  },
  contact_phone: {
    defaultMessage: 'Contact Phone',
    id: 'g9ZCeJ',
    description: 'Contact Phone import column name',
  },
  product_name: {
    defaultMessage: 'Product Name',
    id: 'fJ2e6o',
    description: 'Product Name import column name',
  },
  cost: {
    defaultMessage: 'Product Cost',
    id: 'fuKoiP',
    description: 'Product Cost import column name',
  },
  supplier_sku: {
    defaultMessage: 'Product Supplier SKU',
    id: 'VGkie/',
    description: 'Product Supplier SKU purchase order import column name',
  },
  seller_sku: {
    defaultMessage: 'Product SKU',
    id: 'vBtYeq',
    description: 'Product SKU purchase order import column name',
  },
});
